import { render, staticRenderFns } from "./UpdateQuote.vue?vue&type=template&id=97c4117a&scoped=true"
import script from "./UpdateQuote.vue?vue&type=script&lang=js"
export * from "./UpdateQuote.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=97c4117a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c4117a",
  null
  
)

export default component.exports